export enum COMPANY_TYPE {
  CONSUMER = 'CONSUMER',
  PRODUCER = 'PRODUCER',
}
